__webpack_require__.p = "/wp-content/themes/jakh_theme/assets/";